import { useTranslation } from 'react-i18next';
import { TeContainer, TeGrid } from '@topcon/tuicl-react';

import { Section } from '../../utils/styling';
import Header from '../../components/Header';
import LandingCard from '../../components/LandingCard';
import { AppRoutes } from '../../app/routes/utils';

const Settings = () => {
  const { t } = useTranslation('settings');

  return (
    <TeContainer column grow gap="xs" padding="xs" overflow="auto" alignItems="center">
      <Header text={t('settings')} />
      <Section>
        <TeGrid gap="s">
          <LandingCard
            to={AppRoutes.SettingsGeneralInformation}
            icon="business"
            title={t('generalInformation.title')}
            description={t('generalInformation.description')}
            buttonText={t('generalInformation.changeGeneralInformation')}
          />
          <LandingCard
            to={AppRoutes.SettingsAccess}
            icon="lock_open"
            title={t('access.title')}
            description={t('access.description')}
            buttonText={t('access.changeAccess')}
            iconOutline
          />
          <LandingCard
            to={AppRoutes.Dealers}
            icon="storefront"
            title={t('dealers.title')}
            description={t('dealers.description')}
            buttonText={t('dealers.manageDealers')}
          />
          <LandingCard
            to={AppRoutes.SettingsNotifications}
            icon="notification_settings"
            title={t('notifications.title')}
            description={t('notifications.description')}
            buttonText={t('notifications.manageNotifications')}
          />
          <LandingCard
            to={AppRoutes.SettingsDomainRegistration}
            icon="language"
            title={t('domainRegistration.title')}
            description={t('domainRegistration.description')}
            buttonText={t('domainRegistration.manageDomains')}
          />
          <LandingCard
            to={AppRoutes.SettingsIdentityProviders}
            icon="portrait"
            title={t('identityProviders.title')}
            description={t('identityProviders.description')}
            buttonText={t('identityProviders.manageIdentityProviders')}
            iconOutline
          />
          <LandingCard
            to={AppRoutes.SettingsCustomApps}
            icon="app_registration"
            title={t('customApplications.title')}
            description={t('customApplications.description')}
            buttonText={t('customApplications.manageCustomApplications')}
          />
          <LandingCard
            to={AppRoutes.SettingsDeactivateAccount}
            icon="person_off"
            title={t('deactivateAccount.cardTitle')}
            description={t('deactivateAccount.cardDescription')}
            buttonText={t('deactivateAccount.cardButtonText')}
          />
          <LandingCard
            to={AppRoutes.SettingsLegalDocuments}
            icon="library_books"
            title={t('legalDocuments.title')}
            description={t('legalDocuments.description')}
            buttonText={t('legalDocuments.reviewDocuments')}
            iconOutline
          />
        </TeGrid>
      </Section>
    </TeContainer>
  );
};

export default Settings;
